import './weekly.css';
import "./../Homepage.css";
import React, {useEffect, useState} from "react";

import linebot from './../photos/fp-cad/linebot.webp';
import linebotAngle from './../photos/fp-cad/linebotAngle.webp';
import linebotBottom from './../photos/fp-cad/linebotBottom.webp';
import linebotFront from './../photos/fp-cad/linebotFront.webp';
import linebotSide from './../photos/fp-cad/linebotSide.webp';
import week1circuit from './../photos/fp-cad/week1circuit.webp';
import week1pcb from './../photos/fp-cad/week1pcb.webp';
import week1top from './../photos/fp-cad/week1top.webp';
import week1side from './../photos/fp-cad/week1side.webp';
import wheelCAD from './../photos/fp-cad/wheelCAD.webp';
import IRCAD from './../photos/fp-cad/IRCAD.webp';
import microCAD from './../photos/fp-cad/microCAD.webp';

import badMount from "./../photos/final/badMount.webp";
import imuPrint from "./../photos/final/imuPrint.webp";
import newWeight from "./../photos/final/newWeight.webp";
import sw from "./../photos/final/switch.webp";
import body from "./../photos/final/body.webp";
import imuWarning from "./../photos/final/imuWarning.webp";
import noWeight from "./../photos/final/noWeight.mp4";
import topCut from "./../photos/final/topCut.webp";
import bottomGlue from "./../photos/final/bottomGlue.webp";
import mainBrd from "./../photos/final/mainBrd.webp";
import nose from "./../photos/final/nose.webp";
import topPlaced from "./../photos/final/topPlaced.webp";
import bottomPanel from "./../photos/final/bottomPanel.webp";
import mainSch from "./../photos/final/mainSch.webp";
import placedSwitch from "./../photos/final/placedSwitch.webp";
import wiring from "./../photos/final/wiring.webp";
import chassisCAD from "./../photos/final/chassisCAD.webp";
import milledBoard from "./../photos/final/milledBoard.webp";
import populated from "./../photos/final/populated.webp";
import withWeight from "./../photos/final/withWeight.mp4";
import connector from "./../photos/final/connector.webp";
import motorMount from "./../photos/final/motorMount.webp";
import rearWing from "./../photos/final/rearWing.webp";
import firstDrive from "./../photos/final/firstDrive.mp4";
import newJumper from "./../photos/final/newJumper.webp";
import rp2040pins from "./../photos/final/rp2040pins.webp";
import imuMount from "./../photos/final/imuMount.webp";
import newMount from "./../photos/final/newMount.webp";
import splitCAD from "./../photos/final/splitCAD.webp";

import finalController from "./../code/final/final-controller.ino";
import finalRp2040 from "./../code/final/two-board-test-rp2040.ino";
import wifiHelper from "./../code/final/wifiHelper.h.txt";

import chassisBase from "./../models/final/chassis-base v2.f3d";
import chassisTop from "./../models/final/chassis-top v5.dxf";
import chassis from "./../models/final/chassis.f3d";
import connectorSch from "./../models/final/connector.sch";
import connectorBrd from "./../models/final/connector.brd";
import masterBoardSch from "./../models/final/master_board.sch";
import masterBoardBrd from "./../models/final/master_board.brd";
import motorCircuitSch from "./../models/final/Motor_Circuit.sch";
import motorCircuitBrd from "./../models/final/Motor_Circuit.brd";
import usbcSch from "./../models/final/USBC-breakout.sch";
import usbcBrd from "./../models/final/USBC-breakout.brd";

function Final(props) {
  return (
    <div className="HP-module">
      <div className="HP-subtitle">Final Project - Robot Cart (with sensors)</div>
      <div className="HP-body">
        The inspiration for this project came from one of my previous classes here at MIT where I built a line following robot. My initial goal for that project,
        however, was to create a robot cart that could map it's surroundings using only sensors contained on the robot. This was too ambitious for that class, 
        so I looked to try again in a new class with more preparation and more resources. The goal for the project was to design, create, and assemble most of the 
        parts of the cart and the enclosed circuity, giving it a fun look, being able to control it wirelessly, and finally to collect data and build a map of the 
        room as it drives around. The main questions I looked to answer were what are the important considerations when trying to build a self-contained robot 
        car, as well as is it possible to accurately map a room with just acceleration and linear distance data around the cart. 
      </div>
      <div className="HP-spacer" />
      <div className="HP-subtitle">Previous Work</div>
      <div className="HP-body">
        Through the first 13 weeks of the class I tested many of the subsystems used in this project. I used many of these processes in this project, and if you 
        would like to visit the pages describing in more detail parts of the project they can be found here: 
        <span onClick={() => props.changePage('week3')} className="weekly-pageLink">Wifi on the ESP32-C3</span>,
        <span onClick={() => props.changePage('week9')} className="weekly-pageLink">VL53L1X distance sensors and ESP32-C3 webservers</span>,
        <span onClick={() => props.changePage('week10')} className="weekly-pageLink">brushless motor controller</span>, 
        <span onClick={() => props.changePage('week11')} className="weekly-pageLink">connecting microcontrollers</span>, 
        <span onClick={() => props.changePage('week12')} className="weekly-pageLink">building an interface</span>, and 
        <span onClick={() => props.changePage('week13')} className="weekly-pageLink">fabricating a XIAO</span>
      </div>
      <div className="HP-spacer" />
      <div className="HP-body" >
        Throughout the whole project I used arduino for programming, and Fusion360 for CAD and electronic design. 
        All the schematics, CAD files, and code used in the project can be found at the bottom of the page. 
        Also, since there a lot of components used in this project, all of the datasheets can be found at the end of the final project decumentation. 
      </div>
      <div className="HP-subtitle">The Final Push</div>
      <div className="HP-body">
        With a lot of the initial work done (above) to try out many of these components needed for the project, the goal for the final push was to 
        create a housing for the project and integrate all of the different functionalities, finally using the sensors to build up the map of the room. 
        I started by creating a new main controller board, based around the ESP32-C3, whose purpose is to host a webserver for recieving commands and displaying 
        data, communicate drive commands to the rp2040 motor controller circuit designed in week 13 (see above), and manage the two main sensors: the 
        VL53L1X distance sensor and an accelerometer. I also wanted the circuit to be able to power from a 9V battery, as that is the eventual power source for 
        the self contained cart. I initially wanted to use a buck-boost converter to control the 9V down to 3.3V with minimal power waste, however the 
        converters on hand could only handle inputs up to 6V, and the ESP32-C3 battery pins reccomend {">"}3.3V input, so I opted to use a 5V regulator instead. 
        With all of these parts in mind, I designed a schematic and routed a compact board to fulfill the functionality.
      </div>
      <div className="HP-photoContainer">
          <div className="HP-photoObject">
              <img src={mainSch} className="HP-largePhoto"/>
              <div className="HP-caption">Controller Board Schematic</div>
          </div>
          <div className="HP-photoObject">
              <img src={mainBrd} className="HP-largePhoto"/>
              <div className="HP-caption">Controller Board Footprint</div>
          </div>
      </div>
      <div className="HP-photoContainer">
          <div className="HP-photoObject">
              <img src={milledBoard} className="HP-largePhoto"/>
              <div className="HP-caption">Controller Board Milled</div>
          </div>
          <div className="HP-photoObject">
              <img src={populated} className="HP-largePhoto"/>
              <div className="HP-caption">Controller Board Populated</div>
          </div>
      </div>
      <div className="HP-body">
        I initially opted to place an ADXL343 3-axis accelerometer on the circuit to measure the change in position, planning on calculating the distance between 
        the accelerometer and the distance sensor to roughly esitmate movement. What I failed to remember when designing, however, is that the cart can turn, meaning 
        4 axes were needed to specify acceleration, not just x,y, and z. Realizing this, I opted to use a BNO085, a 9-axis IMU with onboard sensor fusion, a very 
        powerful sensor which could help tremendously with calculating the change in position of the car. Since the BNO085 was available in a breakout board, I 
        opted to keep the original board, ignoring the 3-axis IMU, and instead work with the BNO085 over I2C, which was already speced on the board for the VL53L1X.
        There was one issue however: 
      </div>
      <div className="HP-photoContainer">
          <div className="HP-photoObject">
              <img src={imuWarning} className="HP-largePhoto"/>
              <div className="HP-caption">BNO085 Datasheet Warning</div>
          </div>
      </div>
      <div className="HP-body">
        Since the pesky sensor didn't like to play nice over I2C with my board or the other sensor, I chose to istead interface with it over UART. The ESP32C3 comes 
        equipped with 3 hardware serial interfaces: 1 for USB serial (computer connection), and two more for chip interfacing. One of these interfaces was intended for 
        rp2040 communication, but the other was open for use with the IMU. I used two GPIO pins (9 and 10) not used by the board yet and soldered on a connector, allowing 
        a TX/RX connection to the IMU. The configure the IMU for serial communication instead of I2C one of the configuration pins (D1) also needed to be pulled high, 
        so I also designed a very tiny 5x2 connector for 5 3.3V pins and 5 GND pins for my sensors. 
      </div>
      <div className="HP-photoContainer">
          <div className="HP-photoObject">
              <img src={newJumper} className="HP-largePhoto"/>
              <div className="HP-caption">Controller Board With extra Connector</div>
          </div>
          <div className="HP-photoObject">
              <img src={connector} className="HP-largePhoto"/>
              <div className="HP-caption">Power and Ground Connector</div>
          </div>
      </div>
      <div className="HP-body">
        Plugging this all in, and using the library example code for the sensor, I got the BNO085 to print data to the serial console. I did, however, have to 
        unplug the interrupt pin from the ESP32 circuit, as with it plugged in the speed of the processor tanked significantly likely due to the frequency of 
        interrupts caused by the sensor. 
      </div>
      <div className="HP-photoContainer">
          <div className="HP-photoObject">
              <img src={imuPrint} className="HP-largePhoto"/>
              <div className="HP-caption">BNO085 Output</div>
          </div>
      </div>
      <div className="HP-body">
        With the IMU reading successfully, the next task was to connect the rp2040 based motor controller board to the new board using another 
        serial port. An important note here is that while both using the <a href="https://www.arduino.cc/reference/en/language/functions/communication/serial/ ">Arduino Serial library</a>, 
        the programming for hardware serial on both boards 
        varies significantly. The ESP allows you to pass in pins to the Serial constructor to assign functionality, and any pin can be used, 
        while in the rp2040 the pins must be delared before, and only very specific pins can be used for each Serial interface. Using the wrong pins 
        will not cause a compiler error, but will cause the rp2040 to crash at runtime, which can be difficult to diagnose and recover. Also, as a sanity check, 
        connect board A's RX to board B's TX and vice versa, not RX-RX and TX-TX. I opted to use 
        pins 20 and 21, as while making my XIAO these were the most convenient to breakout: 
      </div>
      <div className="HP-photoContainer">
          <div className="HP-photoObject">
              <img src={rp2040pins} className="HP-largePhoto"/>
              <div className="HP-caption">RP2040 Pin Specification 20-21</div>
          </div>
      </div>
      <div className="HP-body">
        With the two boards connected and sensors configured, it was time to make the chassis for the car. I am a big fan of F1, so I decided it would be fun to design 
        the car to look like an F1 car, to the best of my poor CAD ability. I designed the chassis around my board sizes, which I knew from their fabrication, as well as 
        two 9V batteries. I decided to give myself a lot of room inside the body of the car in case I needed more unforseen electronics, as well as hollowing out the nose 
        to allow wires to pass through it. These wires were needed to configure the sensors, which would sit on the front wing of the car, as well as the motors, which are 
        mounted on either side of the front wing. To fully drive the car, I planned on adding a castor wheen underneath to move the center of rotation when turning to 
        between the two front wheels, or right where the sensors are, to make the calculations easier for sensor fusion later. To this end, I added two fake back wheels to 
        complete the F1 car look as well as a rear wing. I also added small slots in the front wing to mount the motors through, using acrylic mounts I had leftover 
        from a previous project. I then split the model into 3 parts to fit onto the EDS printer beds (nose, body, and rear wing), making sure the 
        ground plane stayed flat for easy additive printing, and started the jobs. I printed the body section in black PLA on the Stratysys F120, and the nose and rear wing 
        on the Sindoh 3DWOX1 in red PLA. The nose also printed support inside to hold up the wire chamber, which was easily removed after the fact with tweezers. 
      </div>
      <div className="HP-photoContainer">
          <div className="HP-photoObject">
              <img src={chassisCAD} className="HP-largePhoto"/>
              <div className="HP-caption">Chassis assembly CAD</div>
          </div>
          <div className="HP-photoObject">
              <img src={splitCAD} className="HP-largePhoto"/>
              <div className="HP-caption">Chassis Split into Two Trays</div>
          </div>
      </div>
      <div className="HP-photoContainer">
          <div className="HP-photoObject">
              <img src={body} className="HP-largePhoto"/>
              <div className="HP-caption">Printed body</div>
          </div>
          <div className="HP-photoObject">
              <img src={nose} className="HP-largePhoto"/>
              <div className="HP-caption">Printed nose</div>
          </div>
      </div>
      <div className="HP-body">
        With the parts printed, the next step was to attach the motors. The original acrylic pieces to mount the motors, however, were too short given the thickness 
        of the front wing. Luckily, this was an easy fix as I simply cut new ones out of acrylic on the laser cutter in EDS and mounted the motors.
      </div>
      <div className="HP-photoContainer">
          <div className="HP-photoObject">
              <img src={badMount} className="HP-largePhoto"/>
              <div className="HP-caption">Original Motor Mounts</div>
          </div>
          <div className="HP-photoObject">
              <img src={newMount} className="HP-largePhoto"/>
              <div className="HP-caption">New Motor Mounts</div>
          </div>
          <div className="HP-photoObject">
              <img src={motorMount} className="HP-largePhoto"/>
              <div className="HP-caption">Mounted Motor</div>
          </div>
      </div>
      <div className="HP-body">
        Next I added the third wheel to the body of the car so that it could fully stant. To add the wheel I first found a centered position in the tapered area of the 
        car and drilled 4 holes in the PLA for the mounting screws. I used standoffs to get the wheel to the right height and to allow the screws to screw in from both sides, 
        as threading PLA is not reasonable. Then, to combine the nose and the body together, I cut out a supporting piece of acrylic to serve as a floorboard for the two 
        pieces, in the shape of a T to increase connected surface area for the two pieces before superglueing them to each other at the joint as well as both pieces to the 
        floorboard. 
      </div>
      <div className="HP-photoContainer">
          <div className="HP-photoObject">
              <img src={bottomPanel} className="HP-largePhoto"/>
              <div className="HP-caption">Floorboard supporting piece</div>
          </div>
          <div className="HP-photoObject">
              <img src={bottomGlue} className="HP-largePhoto"/>
              <div className="HP-caption">Nose and body glued together</div>
          </div>
      </div>
      <div className="HP-body">
        I added another small piece of acrylic to the tapered area of the body on the inside to contain the two 9V batteries, and placed them inside the body. I also 
        placed the two main circuits inside, and connected them together so the car could drive. After connecting the serial lines between the two boards, both boards 
        to 9V power, and the rp2040 board to the motors, I was able to finally see my car drive!
      </div>
      <div className="HP-photoContainer">
          <div className="HP-photoObject">
              <video src={firstDrive} controls className="HP-video"/>
              <div className="HP-caption">First Car Drive</div>
          </div>
      </div>
      <div className="HP-body">
        Next, so that I didnt have to disconnect the batteries every time I wanted to drive the car, I decided to add a switch on the 9V power input. 
        I first soldered both 9V positive and GND terminals to the V+ and GND lines of the switch, respectively, and soldered an out power line and ground line. 
        I then drilled another, much larger, hole in the chassis to house the switch and used a bolt to hold it in place.  
      </div>
      <div className="HP-photoContainer">
          <div className="HP-photoObject">
              <img src={sw} className="HP-largePhoto"/>
              <div className="HP-caption">Power switch wiring</div>
          </div>
          <div className="HP-photoObject">
              <img src={placedSwitch} className="HP-largePhoto"/>
              <div className="HP-caption">Placed power switch</div>
          </div>
      </div>
      <div className="HP-body">
        To continue with the drilling theme, I then decided to mount the sensors to the front wing of the car. I managed to fit all ~10 wires to control both 
        sensors through the nose of the car, and organized them into each IC. I laid all of the VL53L1X wires flat on the wing, and mounted the IMU above them, 
        making sure to center the sensor on the wing, by drilling holes in the wing and bolting the IMU to the wing using standoffs to allow the wiring to pass 
        beneath. 
      </div>
      <div className="HP-photoContainer">
          <div className="HP-photoObject">
              <img src={imuMount} className="HP-largePhoto"/>
              <div className="HP-caption">Mounted sensors on the wing</div>
          </div>
          <div className="HP-photoObject">
              <img src={wiring} className="HP-largePhoto"/>
              <div className="HP-caption">Wiring in the body</div>
          </div>
      </div>
      <div className="HP-body">
        After the wiring was done, I finished the chassis of the car by adding the rear wing of the car, again using superglue to lock it into place. 
      </div>
      <div className="HP-photoContainer">
          <div className="HP-photoObject">
              <img src={rearWing} className="HP-largePhoto"/>
              <div className="HP-caption">Car with rear wing</div>
          </div>
      </div>
      <div className="HP-body">
        With the body of the car complete, it was time to fully enclose the car. I accomplished this by laser cutting another piece of acrylic to seal the body 
        cavity. I exported my body sketch from Fusion360, which gave me issues due to their spline format. To fix that, I found this <a href="https://apps.autodesk.com/FUSION/en/Detail/Index?id=4611814297957846949&appLang=en&os=Mac&autostart=true">
        nice fusion extension</a> to handle DXF conversions to fairly good curve quality. With the top cut out of tinted black acrylic (to match the red and black theme), 
        I mounted the acrylic to the body by drilling four holes in the corners of the chassis walls, and then added slightly smaller screws to the matching spots in 
        the acrylic, effectively forming four alignment pegs which can be slid in and out to place and remove the cover. Note, drilling through acrylic is prone to 
        cracking, however I found reasonable success even close to the edge with slow speeds, sharp bits, and even tapping the holes for screw threads at the end. 
      </div>
      <div className="HP-photoContainer">
          <div className="HP-photoObject">
              <img src={topCut} className="HP-largePhoto"/>
              <div className="HP-caption">Cutting the top panel</div>
          </div>
          <div className="HP-photoObject">
              <img src={topPlaced} className="HP-largePhoto"/>
              <div className="HP-caption">Mounted top panel</div>
          </div>
      </div>
      <div className="HP-body">
        Now that the car was fully assembled and driveable, it was time for some quality testing. First off, the motors produced a very healthy amount of torque, 
        more than enough for the considerably large and heavy car, and posed no concerns. The center of weight, however, was fairly far back, causing the front wheels, 
        while grippy, to slip aggressively when driving and ruin most of the forward effort provided by the motors. To fix this, I decided to weight the front of the car 
        aggressively, bringing the center of mass forward and increasing the normal force between the wheels and the ground so that the wheels would have more friction 
        and could move the car more effectively. To weight it, I found a block of roto281, a castable metal, lying around in about the right wieght and dimensions. 
        Instead of adding new holes to the chassis, I decided to make use of the BNO085 mounts and drilled holes in the weight to match the screw positions of the sensor, 
        tapping the holes, and finally removing the nuts on the BNO085 mount and instead securing them by screwing them into the metal weight. This actually turned 
        out to be a very effective weight, and the car could drive much more effectively. 
      </div>
      <div className="HP-photoContainer">
          <div className="HP-photoObject">
              <img src={newWeight} className="HP-largePhoto"/>
              <div className="HP-caption">Front wing with weight</div>
          </div>
      </div>
      <div className="HP-photoObject">
          <video src={noWeight} controls className="HP-video"/>
          <div className="HP-caption">Car drive without weight</div>
      </div>
      <div className="HP-photoObject">
          <video src={withWeight} controls className="HP-video"/>
          <div className="HP-caption">Car drive with added weight</div>
      </div>
      <div className="HP-subtitle">Ode to ESP32C3</div>
      <div className="HP-body">
        Over the course of this project, specifically in this last week, I've had lots of time eaten up by the strage quirks and outright bugs of this 
        microcontroller. To spare you the time that I've wasted, I'll explain a few of them here and the (if known) fixes. Disclaimer, all of these issues are 
        with the Arduino ESP32C3 specification, at the time of writing this (12/18/23). The first issue deals with the USB Serial port. For whatever reason, 
        the Arduino board library defaults to turning off the "USB CDC on Boot" feature when you first open the board, which is responsible for opening the Serial 
        connection over USB to talk to the microcontroller. If you upload code which prints/recieves Serial commands you will not see it unless you turn this option on. 
        The bigger issue, however, arises if your program crashes at runtime with this option disabled. If you have the USB CDC turned off on Boot, and your program crashes, 
        you will be unable to flash new code to the microcontroller. When the program crashes, you have to put it into boot mode to become responsive (stop crashing), 
        however if the USB connection is turned off for boot, new code cannot be uploaded (you will see an error saying the controller is in the wrong boot mode). To fix this, 
        you can use the strapping pins to your advantage. Connect GPIO8 to 3.3V and GPIO 9 to GND, unplug the board and plug it back in, and now code will be able to be 
        uploaded. To re-enable the USB CDC, however, you have to upload code as described, unstrap the two pins, then reupload code one the controller (hopefully) 
        hasn't crashed with the option enabled in the tool menu.
      </div>
      <div className="HP-body">
        The next flat out bug in the ESP32C3 driver code comes from the I2C implementation. As documented extensively on this site, I've worked with the VL53L1X all semester.
        That is why I was very surprised during integration when I plugged the sensor in and was unable to turn it on. I switched it to the development board featured in week 9,
        uploaded the code from that week, and still no luck. I swapped the microcontroller again, swapped out the sensor, and rewired the circuit with extra  
        resistors to pullup the I2C lines, and still no luck. I even tried a breadboard implementation connecting only 3.3V, GND, SDA, and SCL using the example code 
        given as part of the VL53L1X package, to no avail. Upon using the oscilloscope, it seemed like something was wrong with the SCL line. I was able to fix the code, 
        and discover the sensor by making two bizarre changes: first I explicity declared the I2C pins in the Wire() constructor, which were the defaults anyways, and I 
        explicitly set the SCL line as an output using pinMode(7, OUTPUT), which should be a no-op before intializing I2C. These two changes, however, made the code work. 
        What is strangest, however, is after it worked I was able to remove the changes and the code still worked. Moving this fix over to my main program, I found the same 
        behavior: code cannot find sensor, add in two changes, code can find sensor, remove changes, code can still find sensor. This pattern leads me to believe there is a 
        compiler error translating the Arduino code to the assembly for the ESP32-C3, but I am really not sure where that kind of undefined behaviour could arise. Anyways, 
        these two bugs caused me considerable headaches, so hopefully this can help you solve then faster than I did. 
      </div>
      <div className="HP-subtitle">Files, Code, and Datasheets</div>
      <div className="HP-body">
        <a href="https://www.espressif.com/sites/default/files/documentation/esp32-c3_datasheet_en.pdf">ESP32-C3</a><br/>
        <a href="https://wiki.seeedstudio.com/XIAO_ESP32C3_Getting_Started/">ESP32-C3 XIAO</a><br/>
        <a href="https://datasheets.raspberrypi.com/rp2040/hardware-design-with-rp2040.pdf">RP2040</a><br/>
        <a href="https://cdn-learn.adafruit.com/downloads/pdf/adafruit-9-dof-orientation-imu-fusion-breakout-bno085.pdf">BNO085 IMU</a><br/>
        <a href="https://www.pololu.com/product-info-merged/3415">VL53L1X TOF sensor</a><br/>
        <a href="https://www.ti.com/lit/ds/symlink/drv8847.pdf?HQS=dis-dk-null-digikeymode-dsf-pf-null-wwe&ts=1702266677058">DRV8847 Dual H-Bridge</a><br/>
        <a href="https://www.analog.com/media/en/technical-documentation/data-sheets/ADXL343.pdf">ADXL343 IMU</a><br/>
        <br/>
        <a href="https://wiki.seeedstudio.com/XIAO_ESP32C3_Pin_Multiplexing/">ESP32C3 Serial</a><br/>
        <br />
        <a href={finalController} download="final-controller.ino">ESP32C3 Code</a><br />
        <a href={finalRp2040} download="final-rp2040.ino">RP2040 Code</a><br />
        <a href={wifiHelper} download="wifiHelper.h">Wifi Server Code</a><br />
        <br />
        <a href={masterBoardSch} download="controller_board.sch">Controller Board Schematic</a><br />
        <a href={masterBoardBrd} download="controller_board.brd">Controller Board Footprint</a><br />
        <a href={motorCircuitSch} download="motor_circuit.sch">Motor Board Schematic</a><br />
        <a href={motorCircuitBrd} download="motor_circuit.brd">Motor Board Footprint</a><br />
        <a href={usbcSch} download="usbc.sch">USB-C Breakout Schematic</a><br />
        <a href={usbcBrd} download="usbc.brd">USB-C Breakout Footprint</a><br />
        <a href={connectorSch} download="connector.sch">Connector Schematic</a><br />
        <a href={connectorBrd} download="connector.brd">Connector Footprint</a><br />
        <br/>
        <a href={chassis} download="chassis.f3d">Chassis CAD</a><br />
        <a href={chassisBase} download="chassis_base.f3d">Chassis Base</a><br />
        <a href={chassisTop} download="chassis_top.dxf">Chassis Top DXF</a><br />
      </div>
      <div className="HP-spacer" /><div className="HP-spacer" />
        <div className="HP-subtitle">Final Project Ideas</div>
        <div className="HP-flex">
          <div className="HP-body HP-half">
            During the first week of HTM(a)A we were tasked with designing something in CAD 
            software, specifically a potential final project idea. I have very linited experience with 2-D and 
            3-D CAD, so I emphasized learning different tools while I worked on my design. One of my favorite projects
            I've done here at MIT was my final project for my microcontroller project labratory, which was a line-following robot
            car. I loved building the project, but I never got it working quite as well as I would have liked, so for this project 
            I set out to design a better verion of the line robot as a potential project idea. <br /> <br />
            The line-following robot functions using two photodiodes, one on each side of the front of the car, paired with 
            two LEDs to sense the line underneath it. Light is emitted by the LED, which bounces off of the ground (and the line),
            and is reabsorbed by the photodiode. When a darker line is placed on a brighter surface, less light reflects off of the 
            line, so if one of the photodiodes absorbs more light than the other it means the line is no longer centered, and the 
            data can be used byu a microcontroller to determine how to turn the car. I started off by modeling this electrical circuit,
            along with the motors needed to power the car, in the diagram below.
          </div>
          <div className="HP-photoContent HP-half">
            <div className="HP-photoObject">
              <img src={linebot} className="HP-medPhoto" />
              <div className="HP-caption">My line-following robot from my previous class, and inspiration for this project</div>
            </div>
          </div>
        </div>
        <div className="HP-photoContainer">
          <img src={week1circuit} className="HP-largePhoto"/>
        </div>
        <div className="HP-body">
          Next, now knowing what electrical components I needed to include in my design, I did a rough sketch of the layout of 
          these components, both on a fabricated PCB for housing the electrical components as well as a whole car design with 
          appropriate placement of the motors, wheels, and sensors.
        </div>
        <div className="HP-photoContainer">
          <img src={week1pcb} className="HP-largePhoto"/>
          <img src={week1top} className="HP-largePhoto"/>
          <img src={week1side} className="HP-largePhoto"/>
        </div>
        <div className="HP-body">
          With my 2D inspiration for the new and improved robot car complete, I installed and configured FreeCAD to learn 
          how to model my design in three dimensions. I found my way around the different menus and tools using the demos 
          given to us and by experimenting on my own with the different capabilities of FreeCAD. One of the most useful 
          things in my design was the library of parts availiable to download and use on the internet. Using these importable 
          files I could add to my car things like microcontrollers, circuit components, and wheels without having to design 
          each part by hand. Some of the parts I used can be seen below: 
        </div>
        <div className="HP-photoContainer">
          <img src={wheelCAD} className="HP-medPhoto"/>
          <img src={microCAD} className="HP-medPhoto"/>
          <img src={IRCAD} className="HP-medPhoto"/>
        </div>
        <div className="HP-body">
          Putting together all of these parts along with several I made myself to house the components, I had build the first model 
          of the new and improved line-following robot car. The emphasis in the design was on maximizing component placement for 
          (planned) performance. To this end I made sure the body was small, with only 3 wheels so that it could turn very sharply. 
          Further, I placed the turning wheels as close to in line with the sensors at the front of the vehicle as possible, so that 
          when turning the sensors will stay over the line. I finally roughly modeled my PCB sketched above to be sat on top of the car 
          above the motors. I did not worry much about individual traces or wiring, as that would likely be done closer to fabrication of the 
          project. Finally, here are some renders of the final CAD drawing of my new and improved robot, enjoy!
        </div>
        <div className="HP-photoContainer">
          <img src={linebotAngle} className="HP-medPhoto"/>
          <img src={linebotBottom} className="HP-medPhoto"/>
          <img src={linebotFront} className="HP-medPhoto"/>
          <img src={linebotSide} className="HP-medPhoto"/>
        </div>
        <div className="HP-spacer" />
        <div className="HP-subtitle">New Ideas</div>
        <div className="HP-body">
          Modify the lineBot design to scan a room using a LiDAR sensor or a TOF camera. Instead of following a line around a room make a 
          controllable robot cart that scans it's surroundings using a sensor/camera and map the distance to objects on a display for the user. 
          Ideally this map can build on itself as the robot navigates a room to build a 2D image of the room layout.
        </div>
        <div className="HP-spacer" />
        <div className="HP-spacer" />
    </div>
  );
}

export default Final;